<template>
  <div class="d-flex align-center py-2 nomination-radio-row">
    <div class="cast-name flex-grow-1 text-body-1">
      {{ cast.name || `cast#${cast.id}` }}
    </div>

    <v-radio-group
      :value="selectedVendibleId"
      row
      hide-details
      class="ma-0"
      @change="handleChange"
    >
      <v-radio
        v-for="def in nominationDefs"
        :key="def.id"
        :value="def.id"
        :label="def.name"
      />
      <!-- 解除 -->
      <v-radio
        :value="null"
        label="—"
      />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'NominationRadioRow',
  props: {
    cast: { type: Object, required: true },
    nominationDefs: { type: Array, required: true },
    selectedVendibleId: { type: [Number, String], default: null },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const handleChange = vendibleId => {
      const def = props.nominationDefs.find(d => d.id === vendibleId)
      emit('change', { vendibleId, def })
    }

    return { handleChange }
  },
}
</script>
